import * as React from "react"

function SvgComponent(props) {
    return (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M19.83.914H4.169a1 1 0 00-1 1v3.371a1 1 0 001 1h15.663a1 1 0 001-1v-3.37a1 1 0 00-1-1zM19.83 17.71H4.169a1 1 0 00-1 1v3.372a1 1 0 001 1h15.663a1 1 0 001-1v-3.371a1 1 0 00-1-1zM19.83 9.313H4.169a1 1 0 00-1 1v3.37a1 1 0 001 1h15.663a1 1 0 001-1v-3.37a1 1 0 00-1-1z"
                stroke="currentColor"
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export default SvgComponent
